// extracted by mini-css-extract-plugin
export default {"headBanner":"headBanner_headBanner__OY1Lx"};